import { createFileRoute } from '@tanstack/react-router'
import { DashboardErrorScreen } from '@/components/Error';
import {
    FEATURE_FLAG_ACTIONS,
    FEATURE_FLAG_SUBJECTS,
    withAuthorization,
} from '@/features/Casl';
import { ExecutiveSummaryRouteProvider } from '@/dashboards/ExecutiveSummary/providers';
import {
    ExecutiveSummary,
    executiveSummarySchema,
} from '@/dashboards/ExecutiveSummary';
import { FullPageLoader } from '@analytical-alley/ui';

const ExecutiveSummaryRouteComponent = () => {
    return (
        <ExecutiveSummaryRouteProvider routeId={Route.id}>
            <ExecutiveSummary/>
        </ExecutiveSummaryRouteProvider>
    );
};

export const Route = createFileRoute('/_org/project/$projectId/_dashboards/executive-summary')({
  component: withAuthorization(
    ExecutiveSummaryRouteComponent,
    FEATURE_FLAG_ACTIONS.VIEW,
    FEATURE_FLAG_SUBJECTS.EXECUTIVE_SUMMARY_DASHBOARD,
),
  pendingComponent: FullPageLoader,
  validateSearch: executiveSummarySchema,
  errorComponent: DashboardErrorScreen,
})
